import { useEffect, useState } from "react";
import { showModalPremium } from "../utils/bootstrapUI";
import { useHistory, useLocation } from "react-router-dom";
const id = localStorage.getItem('id');

const useCheckAuth = ({ showModalCheckPremium = false }) => {
  const history = useHistory();
  const location = useLocation()


  const [modalPremiumOpened, setModalPremiumOpened] = useState(false)
  useEffect(() => {
    if (id == null) {
      history.replace(`/login?nextPath=${location.pathname}`)
    }

    if (id && showModalCheckPremium && localStorage.getItem('status') !== '3') {
      showModalPremium();
      setModalPremiumOpened(true)
    }

  }, [showModalCheckPremium])

  return {
    userId: id,
    modalPremiumOpened
  }
}

export default useCheckAuth;